export default class EstimateValue {
        public code: string;

        public name: string;

        public value: string;

        public unit: string;

        constructor() {
          this.code = '';
          this.name = '';
          this.value = '';
          this.unit = '';
        }
}
